import { jsxs, jsx } from 'react/jsx-runtime';

const LargeLink = ({ testId, className, solid })=>{
    return /*#__PURE__*/ jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        "data-testid": testId,
        className: className,
        children: [
            /*#__PURE__*/ jsx("path", {
                d: "M9.40845 6.75028L10.5412 5.61753C12.6979 3.46082 16.2257 3.46082 18.3824 5.61753C20.5392 7.77423 20.5392 11.3021 18.3824 13.4588L17.2497 14.5915",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M14.5915 17.2495L13.4588 18.3822C11.3021 20.5389 7.77423 20.5389 5.61753 18.3822C3.46082 16.2255 3.46082 12.6977 5.61753 10.541L6.75028 9.4082",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M14.7917 9.20813L9.20795 14.7919",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

export { LargeLink as default };
